var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addWidgetSidebar"},[_c('MainButton',{attrs:{"title":"Add widget","clickFunction":function () {_vm.addWidget('income')}}}),_c('Income')],1)}
var staticRenderFns = []

export { render, staticRenderFns }